export default "/static/dashboard/build/app/img/v2/977d2c50de1839ed6834643d896f50e8.png";